export class GeonexAPIError extends Error {
    status: number;
    statusText: string;
    body: string;

    constructor(
        status: number,
        statusText: string,
        body: string,
        context: string,
    ) {
        super(`Failed to fetch ${context}: ${status} ${statusText} - ${body}`);
        console.warn(
            `Failed to fetch ${context}: ${status} ${statusText} - ${body}`,
        );
        this.status = status;
        this.statusText = statusText;
        this.body = body;
    }
}
